module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('BaseBaseAccess'), _c('Home', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path !== '/accessibility'),
      expression: "$route.path !== '/accessibility'"
    }],
    staticClass: "pages-home--desktop"
  }), _c('HomeMobile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path !== '/accessibility'),
      expression: "$route.path !== '/accessibility'"
    }],
    staticClass: "pages-home--mobile"
  }), _c('Accessibility', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path == '/accessibility'),
      expression: "$route.path == '/accessibility'"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3151d4fe","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/base/app.pug
// module id = 534
// module chunks = 1